export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    CategoryIdVeloUpdate: 'specs.events.ui.CategoryIdVeloUpdate',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    StaffPage: 'specs.events.ui.Staff',
    DateAndLocationSettings: 'specs.events.ui.DateLocationSettings',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    DateTimeImprovements: 'specs.events.ui.DateTimeImprovements',
    CategoriesImprovement: 'specs.events.ui.CategoriesImprovement',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    EnablePromoterDevCenterMigration: 'specs.wosbm.migrate-promote-marketing-tools-to-devcenter',
    UpdatedClassicAddPanel: 'specs.events.ui.UpdatedClassicAddPanel',
    EventsLimitWarning: 'specs.events.ui.EventsLimitWarning',
    HoppEntryPoint: 'specs.events.ui.HoppEntryPoint',
    LibraryBasedIOD: 'specs.events.ui.LibraryBasedIOD',
    MultidayEventsCalendar: 'specs.events.ui.MultidayEventsCalendar',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    RecurringEventsImprovements: 'specs.events.ui.RecurringEventsImprovements',
    CheckInBanner: 'specs.events.ui.CheckInBanner',
    DonationInputFix: 'specs.events.ui.DonationInputFix',
    EventPresets: 'specs.events.ui.EventPresets',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations',
    EventsListRedesign: 'specs.events.ui.EventsListRedesign',
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    NewKBArticlesInTicketPreview: 'specs.events.ui.NewKBArticlesInTicketPreview',
    GuestInfoDeletedFields: 'specs.events.ui.GuestInfoDeletedFields',
    EventsListPagination: 'specs.events.ui.EventsListPagination',
    CouponInputEdit: 'specs.events.ui.CouponInputEdit',
    AddMultipleGuestsManually: 'specs.events.ui.AddMultipleGuestsManually',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting',
};
//# sourceMappingURL=experiments.js.map